import { render } from "./SidebarNavVenueGroup.vue?vue&type=template&id=b4484e7c&scoped=true"
import script from "./SidebarNavVenueGroup.vue?vue&type=script&lang=js"
export * from "./SidebarNavVenueGroup.vue?vue&type=script&lang=js"

import "./SidebarNavVenueGroup.vue?vue&type=style&index=0&id=b4484e7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4484e7c"]])

export default __exports__